import { render, staticRenderFns } from "./TermEditAttribute.vue?vue&type=template&id=32b05722&scoped=true"
import script from "./TermEditAttribute.vue?vue&type=script&lang=js"
export * from "./TermEditAttribute.vue?vue&type=script&lang=js"
import style0 from "./TermEditAttribute.vue?vue&type=style&index=0&id=32b05722&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b05722",
  null
  
)

export default component.exports